import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const LoadingScreen = ({ onLoadingComplete }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // Ultra-fast loading - complete in ~0.8 seconds
    const timer = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(timer);
          setTimeout(() => onLoadingComplete(), 150);
          return 100;
        }
        // Very fast progress
        const increment = prev < 60 ? 15 : prev < 90 ? 10 : 5;
        return Math.min(prev + increment, 100);
      });
    }, 25);

    return () => clearInterval(timer);
  }, [onLoadingComplete]);

  return (
    <motion.div
      className="loading-screen-new"
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: 'linear-gradient(135deg, #ffffff 0%, #f0f7ff 50%, #e8f4ff 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        flexDirection: 'column',
        gap: '32px'
      }}
    >
      {/* Animated Logo Container */}
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: 'spring', stiffness: 200, damping: 20 }}
        style={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        {/* Pulsing Ring */}
        <motion.div
          animate={{ scale: [1, 1.2, 1], opacity: [0.5, 0.2, 0.5] }}
          transition={{ duration: 1.5, repeat: Infinity, ease: 'easeInOut' }}
          style={{
            position: 'absolute',
            width: '180px',
            height: '180px',
            borderRadius: '50%',
            border: '2px solid rgba(59, 130, 246, 0.3)'
          }}
        />
        
        {/* Logo */}
        <motion.div
          style={{
            background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
            padding: '24px 32px',
            borderRadius: '16px',
            boxShadow: '0 20px 60px rgba(59, 130, 246, 0.15)',
            border: '1px solid rgba(59, 130, 246, 0.1)'
          }}
        >
          <img 
            src="/PR%20NETCOM%20Transparent%20BG.png"
            alt="P.R. Net Com"
            style={{ width: '160px', height: 'auto' }}
          />
        </motion.div>
      </motion.div>

      {/* Progress Bar */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
        style={{
          width: '200px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '12px'
        }}
      >
        <div style={{
          width: '100%',
          height: '4px',
          background: 'rgba(59, 130, 246, 0.1)',
          borderRadius: '2px',
          overflow: 'hidden'
        }}>
          <motion.div
            style={{
              height: '100%',
              background: 'linear-gradient(90deg, #1e3a8a, #3b82f6)',
              borderRadius: '2px'
            }}
            animate={{ width: `${progress}%` }}
            transition={{ duration: 0.1 }}
          />
        </div>
        
        <motion.span
          style={{
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: '12px',
            color: '#64748b',
            letterSpacing: '2px'
          }}
        >
          {Math.round(progress)}%
        </motion.span>
      </motion.div>

      {/* Tagline */}
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3 }}
        style={{
          fontSize: '14px',
          color: '#3b82f6',
          letterSpacing: '3px',
          textTransform: 'uppercase',
          fontWeight: '500'
        }}
      >
        A Complete IT Solution
      </motion.p>
    </motion.div>
  );
};

export default LoadingScreen;
